import { AxiosError } from 'axios';
import { UseFormGetValues, UseFieldArrayRemove, Path } from 'react-hook-form';
import { WorksheetLinkingFormData } from './LinkPriorWorksheetsForm';
import { Worksheet } from '../../types/worksheet';

/**
 * Removes the sucessfully processed prior worksheet linkings from the Link Prior Worksheets form when when useUpdateWorksheets mutation results in partial error.
 * @param err axiosError containing results of updateWorksheetsQuery
 * @param getValues RHF func to get form values
 * @param remove RHF func to remove form values
 */
export function removeSuccessfulPriorWsLinkings<FieldKey extends keyof WorksheetLinkingFormData>(
    err: AxiosError,
    getValues: UseFormGetValues<WorksheetLinkingFormData>,
    remove: UseFieldArrayRemove,
    fieldName: FieldKey
): void {
    const successfulIds: string[] = err.response?.data.results
        .filter((res: { statusCode: number; error?: Record<string, unknown>; data?: Worksheet }) => res.data !== undefined)
        .map((r: { statusCode: number; data: Worksheet }) => r.data.id);

    if (successfulIds.length > 0) {
        const currentValues = getValues(fieldName);
        const indicesToRemove = successfulIds
            .map((id) => currentValues.findIndex((l) => l.currentWorksheet.id === id))
            .filter((i) => i > -1)
            .sort((a, b) => b - a);

        indicesToRemove.forEach((idx) => remove(idx));
    }
}
